export default "/images/f2a783e05a2c595dffaadd8d7b69e1bf.avif";